'use strict';
module.exports = /* @ngInject */ function () {
    return {
        template: '<div ng-show="inventory.items.length"> \
	    				<span class="text-sm text-{{inventory.availabilityClass}}">' + gettxt.inventory.availability + '</span> \
	    				<span class="badge badge-{{inventory.availabilityClass}}">{{inventory.quantitySum}}</span> \
	     			</div>'
    }
}
